import React, { useEffect, useState } from 'react';
import {
  ALL_DAY_RU,
  ALL_DAY_TIME_RANGE,
  DEFAULT_TIME_TABLE,
  WEEKEND_DEFAULT_TIME_RANGE,
  WEEKEND_RU,
  WORKING_TIME_WEEK_TITLES,
} from 'shared/consts/schedule';
import { Switcher, TimeRangePicker } from 'shared/ui';
import {
  IWeekTimeSlots,
  IWeekWorkTime,
  IWorkingTimeDay,
  WeekDaysEnumEng,
  daysOfWeek,
  daysOfWeekEng,
} from '../../interfaces/time-table-input.interface';
import styles from './week-time-slots.module.scss';

export const WeekTimeSlots: React.FC<IWeekTimeSlots> = ({
  onChangeHandler,
  newTimeTable,
}) => {
  const [timeTable, setTimeTable] = useState<IWeekWorkTime>(newTimeTable);
  const [reserveTimeTable, setReserveTimeTable] =
    useState<IWeekWorkTime>(DEFAULT_TIME_TABLE);

  useEffect(() => {
    onChangeHandler(timeTable);
  }, [timeTable]);

  const isWeekend = (dayTimeRange: IWorkingTimeDay) =>
    dayTimeRange.start === null && dayTimeRange.end === null;
  const isAllDayWorking = (dayTimeRange: IWorkingTimeDay) =>
    dayTimeRange.start === '00:00' && dayTimeRange.end === '00:00';

  const handleDayChange = (data: {
    dayIndex: number;
    timeRange: IWorkingTimeDay;
  }) => {
    const { dayIndex, timeRange } = data;
    const day = daysOfWeekEng[dayIndex];

    setTimeTable((prev) => {
      return { ...prev, [day]: timeRange };
    });
    if (!isWeekend(timeRange) && !isAllDayWorking(timeRange)) {
      setReserveTimeTable((prev) => ({
        ...prev,
        [day]: timeRange,
      }));
    }
  };

  const handleWeekendSwitcher = (day: WeekDaysEnumEng) => {
    const currentTimeRange = timeTable[day];
    if (isWeekend(currentTimeRange)) {
      setTimeTable((prev) => {
        return { ...prev, [day]: reserveTimeTable[day] };
      });
    } else {
      if (!isAllDayWorking(currentTimeRange)) {
        setReserveTimeTable((prev) => {
          return {
            ...prev,
            [day]: currentTimeRange,
          };
        });
      }
      setTimeTable((prev) => {
        return {
          ...prev,
          [day]: {
            start: WEEKEND_DEFAULT_TIME_RANGE[0],
            end: WEEKEND_DEFAULT_TIME_RANGE[1],
          },
        };
      });
    }
  };

  const handleAllDaySwitcher = (day: WeekDaysEnumEng) => {
    const currentTimeRange = timeTable[day];

    if (isAllDayWorking(currentTimeRange)) {
      setTimeTable((prev) => {
        return { ...prev, [day]: reserveTimeTable[day] };
      });
    } else {
      if (!isWeekend(currentTimeRange)) {
        setReserveTimeTable((prev) => {
          return {
            ...prev,
            [day]: currentTimeRange,
          };
        });
      }
      setTimeTable((prev) => {
        return {
          ...prev,
          [day]: {
            start: ALL_DAY_TIME_RANGE[0],
            end: ALL_DAY_TIME_RANGE[1],
          },
        };
      });
    }
  };
  const getTimeRangePickerValue = (dayTimeRange: IWorkingTimeDay) => {
    if (isWeekend(dayTimeRange)) return WEEKEND_RU;
    if (isAllDayWorking(dayTimeRange)) return ALL_DAY_RU;
    return undefined;
  };

  return (
    <div className={styles.content__container}>
      <div className={styles.content__columns_titles}>
        <div className={(styles.columns_title, styles.columns_title_work_time)}>
          {WORKING_TIME_WEEK_TITLES[0]}
        </div>
        <div className={(styles.columns_title, styles.columns_title_weekend)}>
          {WORKING_TIME_WEEK_TITLES[1]}
        </div>
        <div className={(styles.columns_title, styles.columns_title_all_day)}>
          {WORKING_TIME_WEEK_TITLES[2]}
        </div>
      </div>
      <div className={styles.content__days}>
        {daysOfWeekEng.map((dayEng, index: number) => (
          <div key={daysOfWeek[index]} className={styles.days__day}>
            <div className={styles.day__title}>{daysOfWeek[index]}:</div>
            <TimeRangePicker
              index={index}
              value={getTimeRangePickerValue(timeTable[dayEng])}
              timeRange={timeTable[dayEng]}
              onChange={handleDayChange}
            />
            <div className={styles.switcher_container}>
              <Switcher
                isActive={isWeekend(timeTable[dayEng])}
                onClick={() => handleWeekendSwitcher(dayEng)}
              />
            </div>
            <div className={styles.switcher_container}>
              <Switcher
                isActive={isAllDayWorking(timeTable[dayEng])}
                onClick={() => handleAllDaySwitcher(dayEng)}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
